/* eslint-disable */
import React, { useMemo, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from 'antd';
import { CTitle, STitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import link1 from '../../../../../../assets/cybersecurity2026/topic1230pm/section2-pic1.png';
import link2 from '../../../../../../assets/cybersecurity2026/topic1230pm/section2-pic2.png';
import ImgPoint from '../../../../../../assets/cybersecurity2026/finger.gif';

interface ListItem {
  id: string;
  text: string;
  link?: boolean;
}

interface ParagraphsSettings {
  title: string;
  l1Title: string;
  l1SubTitle: string;
  l1Lists: ListItem[];
  l2Title: string;
  l2Lists: string[];
  clickToViewImage: string;
  l3Title1: string;
  l3Title2: string;
}

interface Settings {
  paragraphs: ParagraphsSettings[];
}

interface ISection2Props {
  settings: Settings;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const linkMap: Record<string, string> = {
    '2': link1,
    '3': link2,
  };

  const [open, setOpen] = useState<boolean>(false);
  const [linkPic, setLinkPic] = useState<string>();
  const [clickedLinks, setClickedLinks] = useState<Set<string>>(new Set());
  const [showAllCases, setShowAllCases] = useState<boolean>(false);

  const updateComponentState = useUpdateComponentState();

  const showPicFn = (item: ListItem) => {
    setOpen(true);
    setLinkPic(linkMap[item.id || '']);

    if (item.id) {
      setClickedLinks((prev) => new Set(prev).add(item.id));
    }
  };

  const [state, setState] = useState({
    deepfakeFlagLeft: false,
    deepfakeFlagRight: false,
  });

  useEffect(() => {
    if (clickedLinks.size >= 2) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1230pm-section2-1'
      );
    }
  }, [p_course, p_topic, clickedLinks]);

  useEffect(() => {
    if (clickedLinks.size >= 2) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1230pm-section2-2'
      );
    }
  }, [p_course, p_topic, clickedLinks.size]);

  React.useEffect(() => {
    if (state.deepfakeFlagRight && state.deepfakeFlagLeft) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1230pm-section2-3'
      );
    }
  }, [p_course, p_topic, state.deepfakeFlagLeft, state.deepfakeFlagRight]);

  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.title} />
      {/* section part1 */}
      <div
        className="examples-of-phishing-fraud"
        id="cybersecurity2026-topic1230pm-section2-1"
      >
        <div className="examples-of-phishing-fraud-title">
          <p>{paragraphsSettings?.l1Title}</p>
          <p>{paragraphsSettings?.l1SubTitle}</p>
        </div>

        <div className="examples-of-phishing-fraud-content">
          <div className="examples-of-phishing-fraud-left"></div>
          <div className="examples-of-phishing-fraud-right">
            <div className="content-list">
              {paragraphsSettings?.l1Lists?.map((item) => (
                <div key={item.id} className="content-item">
                  <div>
                    {item.text}
                    {item.link && (
                      <>
                        <span
                          className="content-pic"
                          onClick={() => showPicFn(item)}
                        >
                          {paragraphsSettings?.clickToViewImage}
                        </span>
                        {/* 只有未点击过的链接才显示箭头 */}
                        {!clickedLinks.has(item.id) && (
                          <span className="content-arrow"></span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Modal
          title=""
          width="80%"
          open={open}
          onCancel={() => setOpen(false)}
          footer={null}
        >
          <img src={linkPic} alt="" />
        </Modal>
      </div>
      {/* section1 part2 */}
      <div
        className="case-inspiration"
        id="cybersecurity2026-topic1230pm-section2-2"
      >
        <STitle title={paragraphsSettings?.l2Title} />
        {!showAllCases && <img src={ImgPoint} alt="" className="img-point" />}

        <div
          className={`case-inspiration-list ${showAllCases ? 'show-all' : ''}`}
        >
          {paragraphsSettings?.l2Lists?.map((item, index) => (
            <div
              key={index}
              className={`case-inspiration-item case-inspiration-item-${index}`}
              onClick={() => {
                // 只有点击第一条数据时才触发逐步展示
                if (index === 0 && !showAllCases) {
                  setShowAllCases(true);
                }
              }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
      {/* section1 part3 */}
      <div className="case-study" id="cybersecurity2026-topic900-section2-3">
        <div
          className="case-study-left"
          onClick={() => setState({ ...state, deepfakeFlagLeft: true })}
        >
          {!state.deepfakeFlagLeft ? (
            <img src={ImgPoint} alt="" />
          ) : (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.l3Title1}
            </span>
          )}
        </div>
        <div
          className="case-study-right"
          onClick={() => setState({ ...state, deepfakeFlagRight: true })}
        >
          {!state.deepfakeFlagRight ? (
            <img src={ImgPoint} alt="" />
          ) : (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.l3Title2}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Section2;
